<template>
    <div>
        <input type="text" value="" id="clipElement" />
        <section
            class="section"
            style="padding-bottom: 8px"
            v-show="pageIsDisable == false"
        >
            <div class="contain">
                <div class="printable mob-view-container" id="pdf">
                    <div v-if="fromPreview">
                        <!-- <div style="margin-top: 20px; text-align: left">
                            <img
                                width="300"
                                class="efg-logo"
                                id="ctl00_PlaceHolderMain_efgLogo"
                                :src="
                                    baseUrl + '/new-assets/images/logo.png?v=11'
                                "
                            />
                        </div> -->
                        <div style="width: 85%"></div>
                        <div
                            class="text-center"
                            style="white-space: pre-wrap; margin-bottom: 1.5rem"
                        >
                            {{ data.title }}
                        </div>

                        <!-- <template v-if="!data.client.isPresenter && data.loaded">
                            <div
                                style="
                                    margin-bottom: 1.5rem;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;
                                "
                            >
                                <label
                                    ><b style="color: red"
                                        >Please select your time zone/city so your
                                        schedule appears accordingly.
                                    </b>
                                </label>
                                <div class="timezone-wrapper">
                                    <span style="margin-right: 4px"
                                        ><strong>Time zone:</strong></span
                                    >
                                    <VueSelect
                                        class="w-80"
                                        :options="data.timeZones"
                                        @input="changeTimeZone"
                                        :value="data.selected_timeZone.label"
                                        placeholder="Select Time Zone"
                                    >
                                    </VueSelect>
                                </div>
                            </div>
                        </template>

                        <template v-if="data.client.isPresenter">
                            <div
                                style="
                                    margin-bottom: 1.5rem;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;
                                "
                            >
                                <label
                                    ><b style="color: red"
                                        >Please select your time zone/city so your
                                        schedule appears accordingly.
                                    </b>
                                </label>
                                <div class="timezone-wrapper">
                                    <span style="margin-right: 4px"
                                        ><strong>Time zone:</strong></span
                                    >
                                    <VueSelect
                                        class="w-80"
                                        :options="data.timeZones"
                                        @input="changeTimeZone"
                                        :value="data.selected_timeZone.label"
                                        placeholder="Select Time Zone"
                                    >
                                    </VueSelect>
                                </div>
                            </div>
                        </template> -->

                        <!-- <div
                            style="
                                text-align: center;
                                margin-bottom: 1rem;
                                font-weight: bold;
                            "
                        >
                            <p style="margin-bottom: 0px">
                                The 17<sup>th</sup> Annual One on One Conference
                                6<sup>th</sup> - 9<sup>th</sup> of March 2023
                            </p>
                            <p>Atlantis, The Palm - West Wing</p>
                        </div> -->

                        <div
                            style="
                                display: flex;
                                justify-content: center;
                                margin-bottom: 1rem;
                            "
                        >
                            <ul id="usefulResourceList" class="left-resource-list">
                                <li style="margin: 6px">
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.project.efg.ems&hl=en&gl=US"
                                        target="_blank"
                                    >
                                        <img
                                            :src="baseUrl + '/assets/play.jpg'"
                                            height="50"
                                            alt="..."
                                        />
                                    </a>
                                </li>
                                <li style="margin: 6px">
                                    <a
                                        href="https://apps.apple.com/eg/app/efg-hermes-conferences/id1029064078"
                                        target="_blank"
                                    >
                                        <img
                                            :src="baseUrl + '/assets/apple.jpg'"
                                            height="50"
                                            alt="..."
                                        />
                                    </a>
                                </li>
                            </ul>
                            <div class="border-between"></div>
                            <ul id="usefulResourceList" class="right-resource-list">
                                <li
                                    v-if="!data.client.isPresenter"
                                    style="margin: 6px"
                                >
                                    <a href="/auth/companies" target="_blank">
                                        <img
                                            :src="
                                                baseUrl +
                                                '/assets/presentation.png'
                                            "
                                            height="50"
                                            alt="..."
                                        />
                                    </a>
                                </li>
                                <li v-if="!data.client.isPresenter" style="margin: 6px">
                                    <a
                                        style="cursor: pointer"
                                        href="https://cdn.efghermes.com/Conference/CompanyList.xlsx"
                                    >
                                        <img
                                            :src="
                                                baseUrl + '/assets/company.png'
                                            "
                                            height="50"
                                            alt="..."
                                        />
                                    </a>
                                </li>
                                <!-- <li v-if="!data.client.isPresenter">
                                    <a
                                        href="https://files.efghermes.com/UserFiles/Conferences/89/downloads/Research_Book.pdf"
                                        target="_blank"
                                    >
                                        <img
                                            src="../../assets/researchbooklet.jpg"
                                            alt="..."
                                        />
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a
                                        v-if="!data.client.isPresenter"
                                        href="https://2ndvirtualconference.efghermes.com/UserFiles/Conferences/87/Downloads/joining-webex-meetings-for-investors.pdf"
                                        target="_blank"
                                    >
                                        <img
                                            src="../../assets/webexguide.jpg"
                                            alt="..."
                                        />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        v-if="data.client.isPresenter"
                                        href="https://2ndvirtualconference.efghermes.com/UserFiles/Conferences/87/Downloads/joining-webex-meetings-for-companies.pdf"
                                        target="_blank"
                                    >
                                        <img
                                            src="../../assets/webexguide.jpg"
                                            alt="..."
                                        />
                                    </a>
                                </li> -->
                                <li style="margin: 6px">
                                    <a href="mailto:schedules@efg-hermes.com?subject=Schedule%20Assistance:%20The%20EFG%20Hermes%20Saudi%20Forum%20in%20London">
                                        <img 
                                            data-v-2f726ed5="" 
                                            :src="
                                                baseUrl +
                                                '/assets/contact.png'
                                            "
                                            height="50" 
                                            alt="...">
                                            <!-- src="https://saudiforum.efghermes.com/assets/contact.jpg" -->
                                    </a>
                                </li>

                                <li v-if="data.client.isPresenter" style="margin: 6px">
                                    <a
                                        href="https://cdn.efghermes.com/conference/EFG_PG_London_2023.pdf"
                                        target="_blank"
                                    >
                                        <img
                                            :src="
                                                baseUrl +
                                                '/assets/Participation Guidelines.png'
                                            "
                                            height="50"
                                            alt="..."
                                        />
                                    </a>
                                </li>
                            </ul>  
                        </div>
                        <p
                            style="
                                text-align: center;
                                color: red;
                                font-weight: bold;
                            "
                        >
                            **Please note that the schedules will only be
                            available through the app and will not be printed at
                            the conference venue.**
                        </p>
                    </div>

                    <table>
                        <tr>
                            <td style="width: 200px">
                                <span style="color: #00502e; font-weight: bold"
                                    >Company :</span
                                >
                            </td>
                            <td style="width: auto">
                                {{ data.client.company_name }}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 200px">
                                <span style="color: #00502e; font-weight: bold"
                                    >Representative :</span
                                >
                            </td>
                            <template v-if="data.client.isPresenter">
                                <td
                                    style="width: auto"
                                    v-if="data.client.company"
                                >
                                    <div
                                        v-for="client in companyClientsSortedByJobTitle"
                                        :key="
                                            client.id +
                                            '' +
                                            data.client.company.id
                                        "
                                    >
                                        {{ client.full_titled_name }};
                                        {{ client.job_title }}
                                    </div>
                                </td>
                            </template>
                            <template v-else>
                                <td>
                                    {{ data.client.name }};
                                    {{ data.client.job_title }}
                                </td>
                            </template>
                        </tr>
                        <tr
                            v-if="
                                !data.conf.is_virtual && data.client.isPresenter
                            "
                        >
                            <td style="width: 200px">
                                <span style="color: #00502e; font-weight: bold"
                                    >RoomNo :</span
                                >
                            </td>
                            <td style="width: auto">
                                <a
                                    :href="data.conf.map_link"
                                    class="text_underline"
                                    target="_blank"
                                >
                                    {{ data.room_number }}
                                </a>
                            </td>
                        </tr>
                    </table>
                    <hr />

                    <div
                        v-for="(slots, date) in data.schedule"
                        style="margin-bottom: 8px"
                        :key="date"
                    >
                        <template v-if="data.client.isPresenter">
                            <span
                                v-if="
                                    data.selected_timeZone &&
                                    data.selected_timeZone.label
                                "
                                style="color: #00502e; font-weight: bold"
                                >{{ dataFormat(date, "DD MMMM Y") }}</span
                            >
                        </template>
                        <template v-else>
                            <span style="color: #00502e; font-weight: bold">{{
                                dataFormat(date, "DD MMMM Y")
                            }}</span>
                        </template>
                        <!-- investor view -->
                        <table
                            v-if="!data.client.isPresenter"
                            width="100%"
                            id="dataTable"
                            class="tableHead wid-on-mob"
                            style="border-spacing: 0px"
                        >
                            <thead>
                                <tr>
                                    <th style="width: 15%"><b>Time</b></th>
                                    <!-- <th style="width: 15%">
                                        <b>Presenting Company</b>
                                    </th> -->
                                    <th style="width: 20%">
                                        <b>Meeting Room Details</b>
                                    </th>
                                    <th style="width: 40%">
                                        <b>Representative(s)</b>
                                    </th>
                                    <!-- <th
                                        v-if="
                                            dayHasCompanyMeeting(slots)
                                        "
                                        style="width: 10%; padding-left: 0%; text-align: center;"
                                    >
                                        <b>Action(s)</b>
                                    </th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(slot, index) in slots"
                                    :key="slot.id"
                                    :data-id="slot.id"
                                >
                                    <td style="width: 15%">
                                        <span
                                            style="
                                                display: flex;
                                                margin-top: 4px;
                                                display: block;
                                            "
                                        >
                                            <img
                                                style="
                                                    margin-right: 4px;
                                                    width: 15px;
                                                    height: 15px;
                                                    margin-top: 3px;
                                                "
                                                :src="
                                                    baseUrl +
                                                    '/assets/clock.jpg'
                                                "
                                                alt=""
                                            />
                                            {{ slot.start_time }} -
                                            {{ slot.end_time }}</span
                                        >
                                        <!-- <span
                                            v-if="
                                                data.selected_timeZone &&
                                                data.selected_timeZone.label
                                            "
                                            style="display: flex; margin: auto"
                                        >
                                            Time Zone:
                                            {{ data.selected_timeZone.label }}
                                        </span> -->
                                    </td>

                                    <!-- <td
                                        v-if="slot.type != 1"
                                        style="
                                            vertical-align: top;
                                            text-align: center;
                                            width: 15%;
                                        "
                                    >
                                        <div>
                                            <img
                                                class="company_image"
                                                :src="`../../companies/${slot.company.name}.jpg`"
                                                alt=""
                                            />
                                        </div>
                                    </td> -->

                                    <td v-if="slot.type != 1">
                                        <ul>
                                            <li style="margin-bottom: 0px">
                                                <b>
                                                    {{
                                                        slot.company
                                                            ? slot.company.name
                                                            : "No Company Exist"
                                                    }}</b
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin-bottom: 0px;
                                                    font-weight: lighter;
                                                "
                                            >
                                                {{
                                                    slot.name[
                                                        slot.name.length - 1
                                                    ] === "s"
                                                        ? slot.name.substr(
                                                              0,
                                                              slot.name.length -
                                                                  1
                                                          )
                                                        : slot.name
                                                }}
                                            </li>
                                            <li style="margin-bottom: 0px">
                                                <span
                                                    v-if="
                                                        !data.conf.is_virtual &&
                                                        slot.room &&
                                                        slot.room.room_number
                                                    "
                                                >
                                                    <span> RoomNo : </span>
                                                    <a
                                                        :href="
                                                            data.conf.map_link
                                                        "
                                                        class="text_underline"
                                                        target="_blank"
                                                    >
                                                        (<span
                                                            v-html="
                                                                slot.room
                                                                    .room_number
                                                            "
                                                        ></span
                                                        >)
                                                    </a>
                                                </span>
                                                <span v-else>
                                                    <span
                                                        style="display: block"
                                                        v-if="
                                                            slot.room &&
                                                            slot.room
                                                                .meeting_link
                                                        "
                                                    >
                                                        <div>
                                                            Webex Room:
                                                            <a
                                                                class="link_click"
                                                                target="_blank"
                                                                :href="
                                                                    slot.room
                                                                        .meeting_link
                                                                "
                                                                >CLICK HERE</a
                                                            >
                                                        </div>
                                                        <div
                                                            style="
                                                                padding-left: 10px;
                                                            "
                                                        >
                                                            Meeting ID:
                                                            <span
                                                                style="
                                                                    font-weight: lighter;
                                                                "
                                                            >
                                                                {{
                                                                    slot.room
                                                                        .meeting_id
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div
                                                            style="
                                                                padding-left: 10px;
                                                            "
                                                        >
                                                            Password:
                                                            <span
                                                                style="
                                                                    font-weight: lighter;
                                                                "
                                                            >
                                                                {{
                                                                    slot.room
                                                                        .meeting_password
                                                                }}
                                                            </span>
                                                        </div>
                                                        <!-- <div style="padding-left:10px" > Join by video system: <span style="font-weight:lighter"> {{ slot.room.sip }} </span> </div> -->
                                                        <!-- <div> SIP: {{ slot.room.sip }} </div> -->
                                                    </span>
                                                </span>
                                            </li>
                                        </ul>
                                    </td>

                                    <td v-if="slot.type != 1">
                                        <ul>
                                            <li
                                                style="font-weight: lighter"
                                                v-for="(
                                                    presenter, index
                                                ) in presentersSortedByJobTitle(
                                                    slot.presenters
                                                )"
                                                :key="index"
                                            >
                                                <img
                                                    style="
                                                        margin-right: 4px;
                                                        width: 15px;
                                                        margin-top: 3px;
                                                    "
                                                    :src="
                                                        baseUrl +
                                                        '/assets/person.png'
                                                    "
                                                    alt=""
                                                />
                                                {{
                                                    presenter.full_titled_name
                                                }}; {{ presenter.job_title }}
                                            </li>
                                        </ul>
                                    </td>

                                    <!-- <td
                                        v-if="
                                            slot.type != 1 &&
                                            isInvestorCancellationAllowed &&
                                            isInvestorMeetingCancellationAllowed(slot)
                                        "
                                        class="actions"
                                    >
                                        <button
                                            class="cancel-button"
                                            @click.prevent="
                                                cancelMeetingHandler(
                                                    slot.meeting_id,
                                                    slot.colleagues,
                                                    slots,
                                                    index
                                                )
                                            "
                                        >
                                            Cancel Meeting
                                        </button>
                                    </td>
                                    <td v-else class="actions"></td> -->

                                    <td v-if="slot.type == 1" colspan="4">
                                        <p v-html="slot.description"></p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- presenter view -->
                        <table
                            v-if="
                                data.client.isPresenter &&
                                data.selected_timeZone &&
                                data.selected_timeZone.label
                            "
                            width="100%"
                            id="dataTable"
                            class="tableHead wid-on-mob"
                            style="border-spacing: 0px"
                        >
                            <thead>
                                <tr>
                                    <th style="width: 15%"><b>Time</b></th>
                                    <th style="width: 25%">
                                        <b>Meeting Details</b>
                                    </th>
                                    <th style="width: 30.1%">
                                        <b> Investment Companies </b>
                                    </th>
                                    <th style="width: 40%">
                                        <b>Representative</b>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="slot in slots" :key="slot.id">
                                    <td style="width: 15%">
                                        <span
                                            style="
                                                display: flex;
                                                margin-top: 4px;
                                            "
                                        >
                                            <img
                                                style="
                                                    margin-right: 4px;
                                                    width: 15px;
                                                    height: 15px;
                                                    margin-top: 3px;
                                                "
                                                :src="
                                                    baseUrl +
                                                    '/assets/clock.jpg'
                                                "
                                                alt=""
                                            />
                                            {{ slot.start_time }} -
                                            {{ slot.end_time }}</span
                                        >
                                        <!-- <span
                                            v-if="
                                                data.selected_timeZone &&
                                                data.selected_timeZone.label
                                            "
                                            style="display: flex; margin: auto"
                                        >
                                            Time Zone:
                                            {{ data.selected_timeZone.label }}
                                        </span> -->
                                    </td>
                                    <td v-if="slot.type != 1">
                                        <div style="font-weight: lighter">
                                            {{
                                                slot.name[
                                                    slot.name.length - 1
                                                ] === "s"
                                                    ? slot.name.substr(
                                                          0,
                                                          slot.name.length - 1
                                                      )
                                                    : slot.name
                                            }}
                                            <span
                                                v-if="
                                                    !data.conf.is_virtual &&
                                                    slot.room &&
                                                    slot.room.room_number
                                                "
                                            >
                                                <a
                                                    :href="data.conf.map_link"
                                                    class="text_underline"
                                                    target="_blank"
                                                >
                                                    (<span
                                                        v-html="
                                                            slot.room
                                                                .room_number
                                                        "
                                                    ></span
                                                    >)
                                                </a>
                                            </span>
                                        </div>
                                        <div v-if="data.conf.is_virtual">
                                            <span
                                                style="display: block"
                                                v-if="
                                                    slot.room &&
                                                    slot.room.meeting_link
                                                "
                                            >
                                                <div>
                                                    Webex Meeting Room:
                                                    <a
                                                        class="link_click"
                                                        target="_blank"
                                                        :href="
                                                            slot.room
                                                                .meeting_link
                                                        "
                                                        >CLICK HERE</a
                                                    >
                                                </div>
                                                <div style="padding-left: 10px">
                                                    Meeting ID:
                                                    <span
                                                        style="
                                                            font-weight: lighter;
                                                        "
                                                        >{{
                                                            slot.room.meeting_id
                                                        }}
                                                    </span>
                                                </div>
                                                <div style="padding-left: 10px">
                                                    Password:
                                                    <span
                                                        style="
                                                            font-weight: lighter;
                                                        "
                                                        >{{
                                                            slot.room
                                                                .meeting_password
                                                        }}
                                                    </span>
                                                </div>
                                                <template
                                                    v-if="
                                                        slot.name ==
                                                        'Big Group Meetings'
                                                    "
                                                >
                                                    <div
                                                        style="
                                                            padding-left: 10px;
                                                        "
                                                    >
                                                        Join by video system:
                                                        <span
                                                            style="
                                                                font-weight: lighter;
                                                            "
                                                        >
                                                            {{ slot.room.sip }}
                                                        </span>
                                                    </div>
                                                    <div
                                                        style="
                                                            padding-left: 10px;
                                                        "
                                                    >
                                                        Video System Password:
                                                        <span
                                                            style="
                                                                font-weight: lighter;
                                                            "
                                                        >
                                                            {{
                                                                slot.room
                                                                    .host_key
                                                            }}
                                                        </span>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div
                                                        style="
                                                            padding-left: 10px;
                                                        "
                                                    >
                                                        Host Key:
                                                        <span
                                                            style="
                                                                font-weight: lighter;
                                                            "
                                                        >
                                                            {{
                                                                slot.room
                                                                    .host_key
                                                            }}
                                                        </span>
                                                    </div>
                                                    <div
                                                        style="
                                                            padding-left: 10px;
                                                        "
                                                    >
                                                        Join by video system:
                                                        <span
                                                            style="
                                                                font-weight: lighter;
                                                            "
                                                        >
                                                            {{ slot.room.sip }}
                                                        </span>
                                                    </div>
                                                </template>
                                            </span>
                                        </div>
                                    </td>
                                    <td colspan="2" v-if="slot.type != 1">
                                        <table
                                            style="width: 100%"
                                            cellpadding="0"
                                            cellspacing="0"
                                        >
                                            <tr
                                                v-for="(
                                                    clients, company, index
                                                ) in slot.meetings"
                                                :key="index"
                                                style="margin-bottom: 20px"
                                            >
                                                <td
                                                    style="
                                                        width: 50%;
                                                        font-weight: lighter;
                                                    "
                                                >
                                                    {{ index + 1 }}-
                                                    {{ company }}
                                                </td>
                                                <td
                                                    style="
                                                        width: 50%;
                                                        border-left: 1px solid
                                                            #555;
                                                    "
                                                >
                                                    <table>
                                                        <tr
                                                            v-for="(
                                                                meetingClient,
                                                                index
                                                            ) in clients"
                                                            :key="index"
                                                        >
                                                            <td>
                                                                <div
                                                                    class="popup-wapper"
                                                                >
                                                                    <span
                                                                        style="
                                                                            cursor: pointer;
                                                                            font-weight: lighter;
                                                                        "
                                                                    >
                                                                        <img
                                                                            style="
                                                                                margin-right: 4px;
                                                                                width: 15px;
                                                                                margin-top: 3px;
                                                                            "
                                                                            :src="
                                                                                baseUrl +
                                                                                '/assets/person.png'
                                                                            "
                                                                            alt=""
                                                                        />
                                                                        {{
                                                                            meetingClient
                                                                                .client
                                                                                .full_titled_name
                                                                        }};
                                                                        {{
                                                                            meetingClient
                                                                                .client
                                                                                .job_title
                                                                        }}
                                                                    </span>
                                                                    <div
                                                                        class="popup-body"
                                                                        :id="
                                                                            'client' +
                                                                            meetingClient
                                                                                .client
                                                                                .id
                                                                        "
                                                                    >
                                                                        <span
                                                                            style="
                                                                                font-weight: lighter;
                                                                            "
                                                                        >
                                                                            <strong
                                                                                >Email
                                                                                address:</strong
                                                                            >
                                                                            {{
                                                                                meetingClient
                                                                                    .client
                                                                                    .email
                                                                            }}
                                                                        </span>
                                                                        <span
                                                                            style="
                                                                                font-weight: lighter;
                                                                            "
                                                                        >
                                                                            <strong
                                                                                >Tel:</strong
                                                                            >
                                                                            {{
                                                                                meetingClient
                                                                                    .client
                                                                                    .telephone
                                                                            }}
                                                                        </span>
                                                                        <span
                                                                            style="
                                                                                font-weight: lighter;
                                                                            "
                                                                        >
                                                                            <strong
                                                                                >Biography:</strong
                                                                            >
                                                                            {{
                                                                                meetingClient
                                                                                    .client
                                                                                    .biography
                                                                            }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>

                                    <td
                                        style="width: 80%"
                                        v-if="slot.type == 1"
                                        colspan="3"
                                    >
                                        <!-- <span>Subject : {{ slot.name }}</span> -->
                                        <p v-html="slot.description"></p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <section style="margin-bottom: 8px">
            <div class="contain" style="font-size: 0.8em">
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        padding: 0px 1rem;
                    "
                >
                    <span>{{ data.client.formatted_name }} Agenda</span>
                    <span>{{ pageOpenDate }}</span>
                </div>
                <span style="padding: 0px 1rem"
                    >Provisional Agenda subject to change</span
                >
            </div>
        </section>

        <section class="section" v-show="error_message != ''">
            <div class="contain">
                <div class="alert alert-danger">
                    {{ error_message }}
                </div>
            </div>
        </section>

        <section id="datatableSection">
            <table id="presentationDT">
                <thead>
                    <tr v-if="presenting_companies">
                        <th>Company</th>
                        <th>Country</th>
                        <th>Sector</th>
                        <th>Presentations</th>
                        <th>Research Report</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(company, index) in presenting_companies"
                        :key="index"
                    >
                        <td>{{ company.name }}</td>
                        <td>{{ company.country.name }}</td>
                        <td>{{ company.sector.name }}</td>
                        <td>
                            <span
                                v-if="
                                    company.uploads.length > 0 &&
                                    company.uploads[0].presentation
                                "
                                v-on:click="
                                    downloadFile(company.id, 'presentation')
                                "
                                >Download Presentation</span
                            >
                        </td>
                        <td>
                            <span
                                class="_put-cursor"
                                v-if="
                                    company.uploads.length > 0 &&
                                    company.uploads[0].profile
                                "
                                v-on:click="downloadFile(company.id, 'profile')"
                                >Download Profile</span
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    </div>
</template>

<script>
var _ = require("lodash");
import Api from "@/Api";
import * as jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { mapState } from "vuex";
import VueSelect from "vue-select";

var moment = require("moment");
var momentTZ = require("moment-timezone");

import $ from "jquery";

import JSZip from "jszip";
window.JSZip = JSZip; // required to make Buttons extension work for Excel button

import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "datatables.net-se";
import "datatables.net-buttons-se";

export default {
    name: "Schedule",
    components: { VueSelect },
    props: ['fromPreview'],
    data() {
        return {
            baseUrl: window.location.origin,
            pageIsDisable: false,
            error_message: "",
            data: {
                conf: {},
                schedule: [],
                client: {
                    isPresenter: false,
                    name: "",
                    company_name: "",
                    job_title: "",
                    formatted_name: "",
                },
                title: null,
                room_number: null,
                loaded: false,
                timeZones: [],
                selected_timeZone: { lable: "", code: "" },
            },
            presenting_companies: [],
            client: JSON.parse(localStorage.getItem("client")).client,
            pageOpenDate: `${moment().format("l")} ${moment().format("LTS")}`,
            default_timezone: "Europe/London",
            allowInvestorCancellationDate: null,
        };
    },
    computed: {
        companyClientsSortedByJobTitle() {
            return _.orderBy(this.data.client.company.clients, "job_title");
        },
        isInvestorCancellationAllowed() {
            if (!this.allowInvestorCancellationDate) return false;

            let today = new Date(),
                dateToCompare = new Date(this.allowInvestorCancellationDate);
            // check if today is after allow investor cancellation date
            return today >= dateToCompare;
        },
    },
    methods: {
        isInvestorMeetingCancellationAllowed(slot) {
            let today = new Date(),
                slotDate = new Date(slot.date + ' ' + slot.end_time + ':00');

            return !slot.has_attend && slotDate >= today;
        },
        dayHasCompanyMeeting(slots) {
            return slots.some((slot) => slot.type !== 1);
        },
        cancelMeetingHandler(meetingId, colleagues = [], slots, index) {
            const data = {
                meeting_id: meetingId,
                client_id: this.client.id,
            };

            this.$swal({
                title: "Are you sure you want to cancel this meeting?",
                icon: "warning",
                html: colleagues.length
                    ? "<p>You have colleagues in this meeting</p>" +
                      "<ul>" +
                      colleagues
                          .map(
                              (colleague) =>
                                  "<li class='font-lg'>" +
                                  colleague.name +
                                  "</li>"
                          )
                          .join("") +
                      "</ul>"
                    : "",
                showDenyButton: colleagues.length,
                showCancelButton: true,
                confirmButtonText: "Yes",
                denyButtonText: "Yes, for my colleagues also",
            }).then((result) => {
                if (result.isConfirmed) this.cancelMeeting(data, slots, index);
                else if (result.isDenied) {
                    data.colleagues = colleagues.map(
                        (colleague) => colleague.id
                    );

                    this.cancelMeeting(data, slots, index);
                }
            });
        },
        cancelMeeting(data, slots, index) {
            Api()
                .post("auth/cancel-investor-meeting", data)
                .then((res) => {
                    slots.splice(index, 1);

                    this.$swal("Meeting has been cancelled successfully!", {
                        icon: "success",
                    });
                })
                .catch((err) => console.log(err.response));
        },
        presentersSortedByJobTitle(presenters) {
            return _.orderBy(presenters, "job_title");
        },
        getPageData() {
            let auth = this.client;
            /*if (auth.client_type.type != 1) {
                this.pageIsDisable = true;
                this.error_message = "You dont have access to this page.";
                return;
            }*/

            Api()
                .get("auth/get-schedule")
                .then((response) => {
                    let data = response.data;
                    this.data.client.company = data.company;
                    this.data.client.isPresenter = data.isPresenter;
                    this.data.title = data.title;
                    this.data.conf = data.conf;
                    const confClient = data.conference_client;
                    // this.data.selected_timeZone = (confClient && confClient.timezone ) ? {label: confClient.timezone + " (GMT"+momentTZ.tz(confClient.timezone).format('Z')+")", code: confClient.timezone} : {label: '',code: ''};
                    if (data.isPresenter) {
                        this.data.room_number = data.room_number;
                        this.data.schedule = this.scheduleFormatter(
                            data.schedule
                        );
                    } else {
                        this.data.schedule = data.schedule;
                    }
                    if (this.data.schedule.length == 0) {
                        this.pageIsDisable = true;
                        this.error_message = "Schedule not prepared yet.";
                    }
                    this.changeTimeZone(
                        confClient && confClient.timezone
                            ? {
                                  label:
                                      confClient.timezone +
                                      " (GMT" +
                                      momentTZ
                                          .tz(confClient.timezone)
                                          .format("Z") +
                                      ")",
                                  code: confClient.timezone,
                              }
                            : {
                                  label:
                                      this.default_timezone +
                                      " (GMT" +
                                      momentTZ
                                          .tz(this.default_timezone)
                                          .format("Z") +
                                      ")",
                                  code: this.default_timezone,
                              }
                    );
                    this.data.loaded = true;
                })
                .catch((error) => {
                    this.data.loaded = true;
                    if (error) {
                        if (error.response.status == 422) {
                            this.pageIsDisable = true;
                            var err = error.response.data;
                            this.errors = err.errors;
                        } else if (error.response.status == 401) {
                            this.$store.dispatch("logout");
                            this.$router.push({
                                name: "login",
                                query: {
                                    redirect:
                                        this.$router.currentRoute.fullPath,
                                },
                            });
                            //   this.$router.push('login')

                            // setTimeout(e => this.getPageData(), 5000)
                        }
                    }
                });
        },
        initClientData() {
            let client = JSON.parse(localStorage.getItem("client")).client;
            this.data.client.name = client.full_titled_name;
            this.data.client.job_title = client.job_title;
            this.data.client.formatted_name = client.formatted_name;
            this.data.client.company_name = client.company
                ? client.company.name
                : "No Company Exist";
        },
        download() {
            let client = JSON.parse(localStorage.getItem("client")).client;
            let conferenceId = process.env.VUE_APP_CONFERENCE_ID;
            if (!client) {
                return;
            }
            window.location =
                process.env.VUE_APP_API_URL +
                `/files/auth/download-schedule?conference_id=${conferenceId}&client_id=${client.id}`;
        },

        async convertPageToPDF() {
            var vm = this;
            var html = $("#pdf");
            html.css("padding-left", 100);
            html.css("padding-right", 200);

            html2canvas(html[0]).then(function (canvas) {
                canvas.toBlob(function (blob) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(blob);
                    var img = new Image();
                    img.src = imageUrl;

                    img.onload = function () {
                        console.log("img.width", img.width);
                        console.log("window.outerWidth", window.outerWidth);
                        var pdf = new jsPDF("p", "px", [img.height, img.width]);
                        pdf.addImage(img, "SVG", 0, 0, img.width, img.height);
                        pdf.save(`${vm.data.client.name}.pdf`);
                    };
                });
            });
        },
        sendToMail() {
            var vm = this;
            //send-schedule
            Api()
                .post("auth/send-schedule")
                .then((response) => {
                    alert(response.data.message);
                })
                .catch((error) => {
                    alert("An error has been occured.");
                });
        },
        scheduleFormatter(schedules) {
            var newScheduleFormat = [];
            for (var date in schedules) {
                let slots = schedules[date];
                let newSlots = slots.map((slot) => {
                    slot.meetings = _.groupBy(
                        slot.meetings,
                        (meeting) => meeting.client.company.name
                    );
                });
            }
            return schedules;
        },
        changeTimeZone({ code, label }) {
            Object.keys(this.data.schedule).forEach((date) => {
                this.data.schedule[date] = this.data.schedule[date].map(
                    (slot) => {
                        const startTime = slot.start_time.replace(/\(.+\)/, "");
                        const end_time = slot.end_time.replace(/\(.+\)/, "");
                        slot.start_time = this.convertTimeZone(
                            `${slot.date} ${startTime}`,
                            this.data.selected_timeZone.code ||
                                this.default_timezone,
                            code
                        );
                        slot.end_time = this.convertTimeZone(
                            `${slot.date} ${end_time}`,
                            this.data.selected_timeZone.code ||
                                this.default_timezone,
                            code
                        );
                        return slot;
                    }
                );
            });
            this.data.selected_timeZone.code = code;
            this.data.selected_timeZone.label = label;
        },
        copyPopupData(client) {
            let element = document.getElementById("clipElement");
            let obj = {
                emailaddres: client.email,
                telephone: client.telephone || "",
                biography: client.biography || "",
            };

            element.value = `Email address:${client.email},Tel:${
                client.telephone ? client.telephone : ""
            },Biography:${client.biography ? client.biography : ""}`;
            element.select();
            document.execCommand("Copy");
        },
        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format("L");
            time.tz("Asia/Saudi Arabia");
            const londonTime = time.format("L");
            time.tz(newTimeZone);
            const newTime = time.format("L");
            const diff = moment(newTime).diff(moment(londonTime), "days");
            let res = time.format("HH:mm");
            if (diff) {
                res += "(" + (diff > 0 ? "+" : "") + diff + ")";
            }
            return res;
        },
        dataFormat(data, format) {
            return moment(data).format(format);
        },
        getInvestorCancellationDate() {
            Api()
                .get("auth/investor-cancellation-date")
                .then((res) => {
                    this.allowInvestorCancellationDate =
                        res.data.allow_investor_cancellation_date;
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
    },
    mounted() {
        this.getPageData();
        this.initClientData();
        this.getInvestorCancellationDate();
        this.data.timeZones = this.$store.state.timeZones;
    },
};
</script>

<style scoped>
.right-resource-list {
    padding-left: 20px;
}

.left-resource-list {
    align-self: center; 
    padding-right: 20px;
}

.border-between {
    border-left: 2px solid #00502e;
}
.tableHead > thead > tr {
    width: 100%;
    page-break-inside: avoid;
    page-break-before: auto;
}
.tableHead > thead > tr > th {
    border: 1px solid gray;
    padding-left: 1%;
    background-color: #00502e;
    height: 40px;
    color: #fff;
    width: 20%;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    font-family: Calibri;
}

.tableHead > tbody > tr {
    width: 100%;
    color: black;
    page-break-inside: avoid;
    page-break-before: auto;
}
.tableHead > tbody > tr > td {
    border: 1px solid gray;
    font-weight: bold;
    vertical-align: top;
    padding-left: 1%;
    padding-right: 1%;
    width: 20%;
    font-family: Calibri;
    font-size: 14px;
}

.tableHead > tbody > tr > td > table tr td:nth-child(2) {
    padding-left: 1%;
}

.tableHead > tbody > tr > td > span {
    display: inline-block;
    width: 98%;
}

.tableHead > tbody > tr:nth(1) {
    border: 1px solid gray;
    font-weight: bold;
    vertical-align: top;
    padding-left: 1%;
    width: 20%;
    font-family: Calibri;
    font-size: 14px;
}

.company_image {
    max-width: 130px;
    max-height: 100px;
    object-fit: contain;
    border-radius: 2px;
    margin-top: 10px;
}

#usefulResourceList li {
    white-space: nowrap;
}

#usefulResourceList li {
    white-space: nowrap;
}

#datatableSection {
    display: none;
}
.popup-wapper {
    position: relative;
}

.popup-body {
    position: absolute;
    width: 300px;
    z-index: 1;
    background-color: white;
    padding: 0px 4px;
    display: none;
    box-shadow: 5px 4px 20px #00000029;
    border-radius: 4px;
    border: 1px solid #ccc;
    cursor: unset;
}
.popup-body span {
    display: block;
}

.popup-wapper:hover .popup-body {
    display: block;
}

#clipElement {
    position: absolute;
    top: -9999px;
    left: -9999px;
}

.w-80 {
    width: 50%;
    min-width: 300px;
}
.timezone-wrapper {
    width: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.link_click {
    color: blue;
    text-decoration: underline;
}

@media (max-width: 500px) {
    .mob-view-container {
        overflow: auto;
    }

    .wid-on-mob {
        width: 700px;
    }
    .tableHead > tbody > tr > td {
        font-size: 0.7rem;
    }
    .tableHead > thead > tr > th {
        font-size: 0.7rem;
    }
}
html {
    background: #fff !important;
}
#pdf {
    margin: 15px;
}
.actions {
    text-align: center;
}
.cancel-button {
    border: none;
    margin: 2rem 0;
    background-color: white;
}
</style>
